import { useQuery, useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import { PlusSyncStatusQuery, PlusSyncStatusQueryVariables } from './__generated__/PlusSyncStatusQuery'
import { SyncPlusSubscription, SyncPlusSubscriptionVariables } from './__generated__/SyncPlusSubscription'

const PLUS_SYNC_STATUS_QUERY = gql`
  query PlusSyncStatusQuery($boardId: String!) {
    plusSyncStatusV2(boardId: $boardId) {
      boardId
      inSync
      orderServiceSubscriptionId
      messageServiceSubscriptionId
      orderServiceCurrentPeriodEnd
      messageServicePlusExpiration
      orderServicePaymentProvider
      mismatches
    }
  }
`

const SYNC_PLUS_SUBSCRIPTION_MUTATION = gql`
  mutation SyncPlusSubscription($boardId: String!) {
    syncPlusSubscriptionV2(boardId: $boardId) {
      boardId
      inSync
      orderServiceSubscriptionId
      messageServiceSubscriptionId
      orderServiceCurrentPeriodEnd
      messageServicePlusExpiration
      orderServicePaymentProvider
      mismatches
    }
  }
`

export const usePlusSyncStatus = (boardId: string) => {
  const { data, loading, error, refetch } = useQuery<PlusSyncStatusQuery, PlusSyncStatusQueryVariables>(
    PLUS_SYNC_STATUS_QUERY,
    {
      variables: { boardId },
      fetchPolicy: 'network-only'
    }
  )

  const [syncMutation, { loading: syncing }] = useMutation<SyncPlusSubscription, SyncPlusSubscriptionVariables>(
    SYNC_PLUS_SUBSCRIPTION_MUTATION
  )

  return {
    syncStatus: data?.plusSyncStatusV2 ?? null,
    loading,
    error,
    refetch,
    sync: async () => {
      const result = await syncMutation({ variables: { boardId } })
      return result.data?.syncPlusSubscriptionV2 ?? null
    },
    syncing
  }
}
